<!--<div class="footer-container">-->
<!--  <p>Proyecto Financiado por la Agencia Nacional de Investigación e Innovación (ANII)</p>-->
<!--  <a href="https://www.anii.org.uy/" target="_blank"><img src="../../../assets/img/logo_anni.png"></a>-->
<!--</div>-->
<div class="flex-subcontainer">
  <img class="left-truck" src="assets/img/left-truck.png" alt="símbolo camión">
  <div class="text-container">
    <p>Transporte Eléctrico de Carga: Análisis de los desafíos para su introducción en Uruguay</p>
    <p>Proyecto financiado por el Fondo Sectorial de Energía (FSE) de la ANII</p>
    <a routerLink="/contacto" class="contact-info">contacto<span class="right-arrow-circle"></span></a>
  </div>
</div>
<div class="flex-subcontainer">
  <a target="_blank" href="https://www.um.edu.uy/cinoi"><img class="cinoi-logo" src="assets/img/cinoi-logo.png" alt="logo cinoi"></a>
  <a target="_blank" href="https://www.anii.org.uy/"><img class="anii-logo" src="assets/img/anii-logo.jpg" alt="logo anii"></a>
</div>
